import React from "react";

import HeroBanner from "./HeroBanner";
import Confidentialite from "./Confidentialite";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";
import { usePageSEO } from "../../utils/seoUtils";

const Confidentialites = () => {
  const seoData = usePageSEO('/confidentialite');

  return (
    <>
      <SEOHead {...seoData} />
      <HeroBanner />
      <Confidentialite />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Confidentialites;
